module.exports = "/public/images/424e9e24ac410594c598fa4c5f22c831.svg";